import type { VerbGlossaryEntry } from '@ellie/shared';

interface VerbGlossaryProps {
  entries: VerbGlossaryEntry[];
}

export function VerbGlossary({ entries }: VerbGlossaryProps) {
  if (entries.length === 0) return null;

  return (
    <div className="wb-page">
      <div className="wb-block-header">
        <span className="wb-block-tag wb-conjugation">Verb Glossary</span>
        <h2 className="wb-block-title">Verb Glossary</h2>
        <p className="wb-block-subtitle">All verbs from this workbook with their conjugations</p>
      </div>

      {entries.map((entry, i) => (
        <div key={i} className="wb-glossary-verb">
          <div className="wb-glossary-verb-header">
            <span className="wb-glossary-infinitive">{entry.infinitive}</span>
            <span className="wb-glossary-translation">&mdash; {entry.translation}</span>
            {entry.isIrregular && <span className="wb-glossary-irregular">irregular</span>}
          </div>

          {entry.tenses.map((tense, j) => (
            <div key={j}>
              <div className="wb-conj-tense">{tense.name}</div>
              <table className="wb-conj-table">
                <tbody>
                  <tr>
                    <th>Person</th>
                    <th>Conjugation</th>
                  </tr>
                  {Object.entries(tense.conjugations).map(([person, form]) => (
                    <tr key={person}>
                      <td>{person}</td>
                      <td>{form}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ))}

          {entry.usageNote && (
            <div className="wb-tip" style={{ marginTop: '0.75rem' }}>
              <span className="wb-icon">{'\u{1F4A1}'}</span>
              <p>{entry.usageNote}</p>
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
